import { EntityList } from '../../../common/entityFramework/entityList/EntityList'
import { ExprUtils } from '../../../common/utils/ExprUtils';
import { useCallback } from 'react';

export const Ndc9ProdList = ({ labelerId }) => {

  const augRowsReq = useCallback((rowsReq) => {
    if (!labelerId) return;
    const expr = rowsReq.expr;
    rowsReq.expr = ExprUtils.and(expr, ExprUtils.whereParams('labelerId', labelerId))
  }, [labelerId]);

  return <EntityList entity="NDC9_PROD" augRowsReq={augRowsReq} />
}
